import { Affix, Card, Col, Form, Input, InputNumber, Row, Select, Switch, Table, Checkbox, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import moment from "moment";
import { forwardRef, useCallback, useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  ALL_SALES_CONTRACT_LIST,
  ALL_SALES_CONTRACT_LIST_UPDATED,
  GET_ALL_UNITS,
  GET_CONVERSION_RATE,
  IMPORT_PI_ADD,
  IMPORT_PI_ADD_DOC,
  IMPORT_PI_UPDATE,
} from "../../../../apiServices/API_ENDPOINTS";
import { getData, postData } from "../../../../apiServices/common";
import { alertPop } from "../../../../apiServices/common/helper";
import { toFixedAndComma, isArrayAndHasValue } from "../../../../utils/functions";
import ImportB2blcDocument from "../../../Common/ImportB2blcDocument";
import ImportPiDocument from "../../../Common/ImportPiDocument";
import CustomDatePicker from "common/CustomDatePicker";
import { debounce } from "lodash";
import { useNavigate } from "react-router";

const { Option } = Select;

export const getConversionData = async (pi_unit_id, record, itemDetailsData, setItemDetailsData) => {
  const bodyData = {
    convert_from: record?.unit_id,
    convert_to: pi_unit_id,
    base_value: record?.pi_qty,
  };

  const response = await getData(GET_CONVERSION_RATE, false, bodyData);

  let convertedValue;
  if (response?.data?.code === 200) {
    convertedValue = response?.data?.data;
  } else {
    convertedValue = record?.pi_qty;
  }

  const itemDetailsDataCopy = [...itemDetailsData];

  const findThatItem = itemDetailsDataCopy.find((item) => record?.unique_id === item?.unique_id);
  findThatItem["pi_unit_id"] = pi_unit_id;
  findThatItem["qty_in_bom_unit"] = convertedValue;
  findThatItem["balance_qty"] = Number(record?.required_qty) - Number(convertedValue);

  setItemDetailsData(itemDetailsDataCopy);
};

export const getUnitList = async (setUnitList) => {
  let response = await getData(GET_ALL_UNITS, false, { per_page: 50 });

  if (response) {
    setUnitList(response?.data?.data?.data || []);
  }
};

const AddExportSalesContractForm = forwardRef((props, ref) => {
  const { permitInfo, view, form, show_approve, setLoading, isCreate } = props;

  const [supplier, setSupplier] = useState([]);
  const [itemsValue, setItemsValue] = useState(0);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [additionalCharge, setAdditionalCharge] = useState(0);
  const [deductionAmount, setDeductionAmount] = useState(0);
  const [styleNo, setStyleNo] = useState([]);
  const [filesList, setFileList] = useState([]);
  const [b2bLcDocuments, setB2bLcDocuments] = useState([]);
  const [salesContractList, setSalesContractList] = useState([]);
  const [itemDetailsData, setItemDetailsData] = useState([]);
  const [categoryMapData, setCategoryMapData] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [isItemizedView, setIsItemizedView] = useState(false);
  const [groupPiQuantities, setGroupPiQuantities] = useState({});
  const [isItemsLoading, setIsItemsLoading] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [groupPiUnits, setGroupPiUnits] = useState({});
  const [groupMaxQty, setGroupMaxQty] = useState({});
  const [parentGroupBomQty, setParentGroupBomQty] = useState({});
  const navigate = useNavigate();

  var document = [];
  var document_name = [];

  const onFinishSalesContract = async (values) => {
    setLoading(true);
    values["is_b2blc_open"] = values.is_b2blc_open ? "1" : "0";
    values["is_nominated"] = values.is_nominated ? "Yes" : "No";

    const item_details = itemDetailsData.map((item) => {
      return {
        id: isCreate ? 0 : item.id || 0,
        category_id: item.category_id,
        item_id: item.item_id,
        bom_detail_id: item.bom_detail_id,
        unit_id: item.unit_id,
        style_id: item.style_id,
        pi_qty: item.pi_qty,
        pi_unit_id: item.pi_unit_id || item.unit_id,
        qty_in_bom_unit: item.qty_in_bom_unit,
        balance_qty: item.balance_qty || 0,
        rate: item.rate || 0,
        amount: item.amount || 0,
        category_wise_view: checkedItems.includes(item.unique_id) ? "yes" : "no",
        is_delete: 0,
      };
    });

    const documents = [];
    if (filesList?.length) {
      filesList.forEach((item) => {
        documents.push({
          id: item?.id || 0,
          is_delete: 0,
          document_name: item?.name,
          document: item?.path || `storage/import_pi_document/${item?.name}`,
        });
      });
    }

    const category_maps = isArrayAndHasValue(categoryMapData)
      ? categoryMapData.map((item) => {
          return {
            id: item?.id || 0,
            item_category_id: item?.item_category_id,
            expected_in_house_date: item?.expected_in_house_date
              ? moment(item?.expected_in_house_date).format("YYYY-MM-DD")
              : null,
            is_delete: item?.is_delete || 0,
          };
        })
      : [];

    const bodyData = {
      sales_contract_id: values?.sales_contract_id,
      pi_number: values?.pi_number,
      pi_date: values?.pi_date ? moment(values?.pi_date)?.format("YYYY-MM-DD") : null,
      supplier_id: values?.supplier_id,
      style_no: values?.style_no,
      goods_description: values?.goods_description,
      buyer: values?.buyer,
      buyer_id: values?.buyer_id,
      items_value: values?.items_value || 0,
      items_quantity: values?.items_quantity || 0,
      service_charge: values?.service_charge || 0,
      additional_charge: values?.additional_charge || 0,
      deduction_amount: values?.deduction_amount || 0,
      pi_value: values?.pi_value || 0,
      trade_term: values?.trade_term,
      pay_term: values?.pay_term,
      payment_mode: values?.payment_mode,
      ship_mode: values?.ship_mode,
      ship_date: values?.ship_date ? moment(values?.ship_date)?.format("YYYY-MM-DD") : null,
      eta: values?.eta ? moment(values?.eta)?.format("YYYY-MM-DD") : null,
      is_b2blc_open: values?.is_b2blc_open,
      status: view ? "Approved" : values?.status,
      is_nominated: values?.is_nominated,
      item_details,
      documents,
      category_maps,
    };

    if (permitInfo && permitInfo?.id) {
      bodyData.id = permitInfo.id;
    }

    try {
      if (bodyData?.id > 0) {
        const response = await postData(`/api/accounting/import-pi/update-cr/` + bodyData?.id, bodyData);

        if (response && response?.code === 200) {
          alertPop("success", "Proforma Invoice Updated Successfully");
          navigate("/import/pi");
        }
      } else {
        const response = await postData(`/api/accounting/import-pi/store-cr`, bodyData);

        if (response && response?.code === 200) {
          alertPop("success", "Proforma Invoice Added Successfully");
          navigate("/import/pi");
        }
      }
    } catch (error) {
      alertPop("error", error);
    } finally {
      setLoading(false);
    }
  };

  const getSalesContractList = async (value = "") => {
    try {
      let res = await getData(ALL_SALES_CONTRACT_LIST_UPDATED, false, {
        reference_no: value,
        per_page: 100,
      });

      if (res) {
        setSalesContractList(res?.data?.data?.data || []);
      }
    } catch (error) {}
  };

  const debouncedGetSalesContractList = useMemo(() => debounce(getSalesContractList, 300), []);

  useEffect(() => {
    getSalesContractList();
    getUnitList(setUnitList);
  }, []);

  const funcExam = useCallback(async () => {
    const sales_contract_commercial_value = permitInfo?.sales_contract_commercial;

    if (sales_contract_commercial_value) {
      const sales_contract_id_edit = sales_contract_commercial_value?.sales_contract_id;

      const selectedContract = salesContractList.find((contract) => contract.id === sales_contract_id_edit);

      if (selectedContract) {
        setSupplier(selectedContract.suppliers || []);

        const styleOptions =
          selectedContract.styles?.map((style) => ({
            value: style.id,
            label: style.style_no,
            description: style.description,
          })) || [];
        setStyleNo(styleOptions);

        const selected_style_no = sales_contract_commercial_value?.style_no;
        let selected_style_ids = [];

        if (selected_style_no) {
          const splitted_style_ids = selected_style_no.toString().split(",");
          selected_style_ids = splitted_style_ids?.filter((id) => id.trim())?.map((item) => Number(item.trim()));
        }

        let itemsArr = [];
        if (sales_contract_commercial_value?.import_pi_items) {
          sales_contract_commercial_value.import_pi_items.forEach((item) => {
            const uniqueId = Math.floor(Math.random() * 1000);
            itemsArr.push({
              id: uniqueId,
              unique_id: item?.unique_id || uniqueId,
              category_name: item?.category_info?.name,
              category_id: item?.category_info?.id || item?.category_id,
              item_name: item?.item_info?.name,
              item_id: item?.item_info?.id || item?.item_id,
              bom_detail_id: item?.bom_detail_id,
              unit_name: item?.unit_info?.name,
              unit_id: item?.unit_info?.id || item?.unit_id,
              style_no: item?.style_info?.style_no,
              style_id: item?.style_info?.id || item?.style_id,
              required_qty: item.required_qty,
              pi_qty: item.pi_qty,
              pi_unit_id: item?.pi_unit_id,
              qty_in_bom_unit: item?.qty_in_bom_unit,
              balance_qty: item.balance_qty,
              rate: item.rate,
              amount: item.amount,
              expected_in_house_date: item?.expected_in_house_date,
            });
          });
        }

        setItemDetailsData(itemsArr);
        setCategoryMapData(sales_contract_commercial_value?.category_map || []);

        let b2b_lc_documents = [];
        permitInfo?.b2b_lc_relation?.b2blc_document.map((item, index) => {
          b2b_lc_documents.push({
            id: item?.id,
            name: item?.document_name,
            path: item?.document,
          });
        });

        form.setFieldsValue({
          ...sales_contract_commercial_value,
          sales_contract_id: sales_contract_id_edit,
          supplier_id: sales_contract_commercial_value?.supplier_id,
          style_no: selected_style_ids,
          buyer: selectedContract?.buyer_info?.name || sales_contract_commercial_value?.buyer,
          buyer_id: selectedContract?.buyer_info?.id || sales_contract_commercial_value?.buyer_id,
          is_b2blc_open:
            sales_contract_commercial_value?.is_b2blc_open === 1 ||
            sales_contract_commercial_value?.is_b2blc_open === "1",
          pi_date: sales_contract_commercial_value?.pi_date
            ? moment(sales_contract_commercial_value?.pi_date, "YYYY-MM-DD")
            : null,
          ship_date: sales_contract_commercial_value?.ship_date
            ? moment(sales_contract_commercial_value?.ship_date, "YYYY-MM-DD")
            : null,
          eta: sales_contract_commercial_value?.eta ? moment(sales_contract_commercial_value?.eta, "YYYY-MM-DD") : null,
          in_house_date: sales_contract_commercial_value?.in_house_date
            ? moment(sales_contract_commercial_value?.in_house_date, "YYYY-MM-DD")
            : null,
        });
      }
    }
  }, [form, permitInfo, salesContractList]);

  useEffect(() => {
    if (permitInfo?.sales_contract_commercial) {
      funcExam();
    } else if (permitInfo) {
      populateFromPermitInfo(permitInfo);
    }
  }, [permitInfo, salesContractList, funcExam]);

  const populateFromPermitInfo = (permitInfo) => {
    try {
      if (!permitInfo) return;

      if (permitInfo.supplier_info) {
        setSupplier([permitInfo.supplier_info]);
      }

      if (isArrayAndHasValue(permitInfo.styles)) {
        const styleOptions = permitInfo.styles.map((style) => ({
          value: style.id,
          label: style.style_no,
          description: style.description,
        }));
        setStyleNo(styleOptions);
      }

      let itemsArr = [];
      const hasCategoryWiseView =
        isArrayAndHasValue(permitInfo.import_pi_items) &&
        permitInfo.import_pi_items.some((item) => item.category_wise_view === "yes");

      if (isArrayAndHasValue(permitInfo.import_pi_items)) {
        itemsArr = permitInfo.import_pi_items.map((item) => ({
          id: item.id,
          unique_id: item.unique_id || item.id,
          category_name: item?.category_info?.name,
          category_id: item?.category_info?.id || item?.category_id,
          item_name: item?.item_info?.name,
          item_id: item?.item_id,
          bom_detail_id: item?.bom_detail_id,
          unit_name: item?.unit_info?.name,
          unit_id: item?.unit_info?.id || item?.unit_id,
          style_no: item?.style_info?.style_no,
          style_id: item?.style_info?.id || item?.style_id,
          required_qty: item.pi_qty + item.balance_qty,
          pi_qty: item.pi_qty,
          pi_unit_id: item?.pi_unit_id,
          qty_in_bom_unit: item?.qty_in_bom_unit,
          balance_qty: item.balance_qty,
          rate: item.rate,
          amount: item.amount,
          category_wise_view: item.category_wise_view,
        }));

        if (hasCategoryWiseView) {
          setIsItemizedView(true);

          const itemsToCheck = permitInfo.import_pi_items
            .filter((item) => item.category_wise_view === "yes")
            .map((item) => item.unique_id || item.id);

          if (itemsToCheck.length > 0) {
            setCheckedItems(itemsToCheck);

            const firstItem = permitInfo.import_pi_items.find((item) => item.category_wise_view === "yes");
            if (firstItem) {
              setSelectedCategoryId(firstItem.category_id);
            }
          }
        }
      }

      if (isArrayAndHasValue(permitInfo.pi_category_map_info)) {
        setCategoryMapData(permitInfo.pi_category_map_info);
      }

      if (isArrayAndHasValue(permitInfo.pi_document)) {
        const docs = permitInfo.pi_document.map((doc) => ({
          id: doc.id,
          name: doc.document_name,
          path: doc.document,
        }));
        setFileList(docs);
      }

      let b2b_lc_documents = [];
      permitInfo?.b2b_lc_relation?.b2blc_document.map((item, index) => {
        b2b_lc_documents.push({
          id: item?.id,
          name: item?.document_name,
          path: item?.document,
        });
      });

      setB2bLcDocuments(b2b_lc_documents);

      form.setFieldsValue({
        sales_contract_id: permitInfo.sales_contract_id,
        pi_number: permitInfo.pi_number,
        pi_date: permitInfo.pi_date ? moment(permitInfo.pi_date, "YYYY-MM-DD") : null,
        supplier_id: permitInfo.supplier_id,
        style_no: permitInfo.style_no
          ? permitInfo.style_no
              .toString()
              .split(",")
              .map((id) => Number(id.trim()))
          : [],
        goods_description: permitInfo.goods_description,
        buyer: permitInfo.buyer,
        buyer_id: permitInfo.buyer_id,
        items_value: permitInfo.items_value,
        items_quantity: permitInfo.items_quantity,
        service_charge: permitInfo.service_charge || 0,
        additional_charge: permitInfo.additional_charge || 0,
        deduction_amount: permitInfo.deduction_amount || 0,
        pi_value: permitInfo.pi_value,
        trade_term: permitInfo.trade_term,
        pay_term: permitInfo.pay_term,
        payment_mode: permitInfo.payment_mode,
        ship_mode: permitInfo.ship_mode,
        ship_date: permitInfo.ship_date ? moment(permitInfo.ship_date, "YYYY-MM-DD") : null,
        eta: permitInfo.eta ? moment(permitInfo.eta, "YYYY-MM-DD") : null,
        is_b2blc_open: permitInfo.is_b2blc_open === 1 || permitInfo.is_b2blc_open === "1",
        is_nominated: permitInfo.is_nominated === "Yes",
        status: permitInfo.status || "Created",
      });

      setItemsValue(permitInfo.items_value || 0);
      setServiceCharge(permitInfo.service_charge || 0);
      setAdditionalCharge(permitInfo.additional_charge || 0);
      setDeductionAmount(permitInfo.deduction_amount || 0);
      setItemDetailsData(itemsArr);
    } catch (error) {}
  };

  const handleSalesContractChange = (contractId) => {
    const selectedContract = salesContractList.find((contract) => contract.id === contractId);

    if (selectedContract) {
      setSupplier(selectedContract.suppliers || []);

      const styleOptions =
        selectedContract.styles?.map((style) => ({
          value: style.id,
          label: style.style_no,
          description: style.description,
        })) || [];
      setStyleNo(styleOptions);

      form.setFieldsValue({
        buyer: selectedContract.buyer_info?.name || "",
        buyer_id: selectedContract.buyer_info?.id || "",
        supplier_id: undefined,
        style_no: [],
      });
    }
  };

  const roundToTwo = (num, decimalPlaces = 0) => {
    if (num < 0) return -roundToTwo(-num, decimalPlaces);
    var p = Math.pow(10, decimalPlaces);
    var n = num * p;
    var f = n - Math.floor(n);
    var e = Number.EPSILON * n;

    return f >= 0.5 - e ? Math.ceil(n) / p : Math.floor(n) / p;
  };

  const getItemDetails = async (styleIds) => {
    itemDetailsData.length = 0;
    const supplier_id = form.getFieldValue("supplier_id");
    const sales_contract_id = form.getFieldValue("sales_contract_id");

    if (Array.isArray(styleIds) && styleIds.length > 0 && supplier_id && sales_contract_id) {
      const styleIdStr = styleIds.join(",");

      let styleIdArr = [];
      styleIdArr = styleIds
        .flatMap((id) => id.toString().split(","))
        .map((id) => Number(id.trim()))
        .filter((id) => !isNaN(id));

      const body = {
        style_id: styleIdArr,
        supplier_id: supplier_id,
        sales_contract_id: sales_contract_id,
      };

      setIsItemsLoading(true);

      let res = await getData("/api/accounting/import-pi/get-item-details", false, body);

      let item_array = [];
      const item_details_data = isArrayAndHasValue(res?.data?.data?.item_details)
        ? [...res?.data?.data?.item_details]
        : null;

      if (item_details_data) {
        item_details_data.forEach((item) => {
          const uniqueId = uuidv4();
          item_array.push({
            id: uniqueId,
            unique_id: item?.unique_id || uniqueId,
            category_name: item?.pi_item_category_info?.name,
            category_id: item?.pi_item_category_info?.id,
            item_name: item?.pi_item_info?.name,
            item_id: item?.pi_item_info?.id,
            bom_detail_id: item?.bom_detail_id,
            unit_name: item?.unit_info?.name,
            unit_id: item?.unit_info?.id,
            style_no: item?.bom_info?.style_no,
            style_id: item?.bom_info?.style_id,
            required_qty: item?.remaining_qty,
            pi_qty: item?.remaining_qty, // Initialize with remaining_qty
            pi_unit_id: item?.unit_info?.id,
            qty_in_bom_unit: item?.remaining_qty, // Initialize with remaining_qty
            balance_qty: 0, // Since we're using full remaining qty
            rate: 0,
            amount: 0,
            category_wise_view: item?.category_wise_view,
          });
        });
      }

      const category_map_data = isArrayAndHasValue(res?.data?.data?.category_map)
        ? [...res?.data?.data?.category_map]
        : null;

      setCategoryMapData(category_map_data);
      setItemDetailsData([...item_array]);
      setIsItemsLoading(false);
    }
  };

  const getTotalPriceOfItem = (value, data, idx, context) => {
    if (itemDetailsData) {
      itemDetailsData.forEach((item) => {
        if (item.unique_id === idx) {
          item["rate"] = value;
          item[context] = (item.pi_qty || 0) * (value || 0);
        }
      });
    }

    setItemDetailsData([...itemDetailsData]);
  };

  const getTotalPriceOfItemByPiQty = async (value, data, idx, context) => {
    const updatedItemDetailsData = [...itemDetailsData];
    const itemIndex = updatedItemDetailsData.findIndex((item) => item.unique_id === idx);

    if (itemIndex !== -1) {
      const item = updatedItemDetailsData[itemIndex];

      // Add validation to check if PI QTY exceeds remaining qty
      if (value > Number(item.required_qty)) {
        alertPop("warning", `PI quantity cannot exceed remaining quantity (${toFixedAndComma(item.required_qty)})`);
        return;
      }

      item.pi_qty = value;
      item.amount = (Number(value) || 0) * (Number(item.rate) || 0);

      if (item.pi_unit_id && item.pi_unit_id !== item.unit_id) {
        const conversionData = {
          convert_from: item.pi_unit_id,
          convert_to: item.unit_id,
          base_value: value,
        };

        const response = await getData(GET_CONVERSION_RATE, false, conversionData);
        if (response?.data?.code === 200) {
          item.qty_in_bom_unit = response.data.data;
          item.balance_qty = Math.max(0, item.required_qty - response.data.data);
        }
      } else {
        item.qty_in_bom_unit = value;
        item.balance_qty = Math.max(0, item.required_qty - value);
      }
    }

    setItemDetailsData(updatedItemDetailsData);
  };

  useEffect(() => {
    let pi_value_total = 0;

    itemDetailsData &&
      itemDetailsData.forEach((item) => {
        pi_value_total += item.amount;
      });

    let restTotal = Number(deductionAmount) + Number(serviceCharge) + Number(additionalCharge);
    form.setFieldsValue({
      pi_value: roundToTwo(pi_value_total - restTotal, 2),
    });
  }, [itemDetailsData, serviceCharge, additionalCharge, deductionAmount]);

  useEffect(() => {
    const totalSum = itemDetailsData.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.amount;
    }, 0);

    const totalQuantity = itemDetailsData.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.pi_qty);
    }, 0);

    setItemsValue(totalSum);

    form.setFieldsValue({
      items_value: roundToTwo(totalSum, 2),
      items_quantity: totalQuantity,
      service_charge: serviceCharge,
      additional_charge: additionalCharge,
      deduction_amount: deductionAmount,
      pi_value: roundToTwo(totalSum - (serviceCharge + additionalCharge + deductionAmount), 2),
    });
  }, [itemDetailsData]);

  const updatePiValueByService = (event) => {
    setServiceCharge(event.target.value);
    let restTotal = Number(event.target.value) + Number(additionalCharge) + Number(deductionAmount);
    let total_cm = itemsValue - restTotal;
    form.setFieldsValue({
      pi_value: roundToTwo(total_cm, 2),
    });
  };

  const updatePiValueByAdditionalCharge = (event) => {
    setAdditionalCharge(event.target.value);
    let restTotal = Number(event.target.value) + Number(serviceCharge) + Number(deductionAmount);
    let total_cm = itemsValue - restTotal;
    form.setFieldsValue({
      pi_value: total_cm,
    });
  };

  const updatePiValueByDeductionAmount = (event) => {
    setDeductionAmount(event.target.value);
    let restTotal = Number(event.target.value) + Number(serviceCharge) + Number(additionalCharge);
    let total_cm = itemsValue - restTotal;
    form.setFieldsValue({
      pi_value: total_cm,
    });
  };

  const onChangeInHouseDate = (date, record) => {
    if (view) return;

    const customDate = moment(date).format("YYYY-MM-DD");
    const categoryMapDataCopy = structuredClone(categoryMapData);
    const foundItem =
      isArrayAndHasValue(categoryMapDataCopy) &&
      categoryMapDataCopy?.find((item) => item?.item_category_id === record?.item_category_id);
    foundItem["expected_in_house_date"] = customDate;
    setCategoryMapData(categoryMapDataCopy);
  };

  const canItemBeChecked = (record) => {
    return true;
  };

  const handleItemCheck = (record, checked) => {
    if (view) return;

    if (checked && canItemBeChecked(record)) {
      if (checkedItems.length === 0) {
        setSelectedCategoryId(record.category_id);
      }
      setCheckedItems((prev) => [...prev, record.unique_id]);
    } else if (!checked) {
      const newCheckedItems = checkedItems.filter((id) => id !== record.unique_id);
      setCheckedItems(newCheckedItems);

      if (newCheckedItems.length === 0) {
        setSelectedCategoryId(null);
        setGroupPiQuantities({});
      } else {
        const remainingCategories = new Set(
          itemDetailsData.filter((item) => newCheckedItems.includes(item.unique_id)).map((item) => item.category_id),
        );
        if (!remainingCategories.has(selectedCategoryId)) {
          setSelectedCategoryId([...remainingCategories][0]);
        }
      }
    }
  };

  useEffect(() => {
    if (checkedItems.length === 0) return;

    const referenceItem = itemDetailsData.find((item) => checkedItems.includes(item.unique_id));
    if (!referenceItem) return;

    const validChecked = checkedItems.filter((id) => {
      const item = itemDetailsData.find((i) => i.unique_id === id);
      return (
        item &&
        ((item.category_id === referenceItem.category_id &&
          (item.pi_unit_id || item.unit_id) === (referenceItem.pi_unit_id || referenceItem.unit_id) &&
          item.rate === referenceItem.rate) ||
          Array.from(
            new Set(
              checkedItems.map((cid) => {
                const checkedItem = itemDetailsData.find((di) => di.unique_id === cid);
                return checkedItem && checkedItem.category_id;
              }),
            ),
          ).some((catId) => {
            const catItem = itemDetailsData.find(
              (di) => di.category_id === catId && checkedItems.includes(di.unique_id),
            );
            return (
              catItem &&
              (item.pi_unit_id || item.unit_id) === (catItem.pi_unit_id || catItem.unit_id) &&
              item.rate === catItem.rate
            );
          }))
      );
    });

    if (validChecked.length !== checkedItems.length) {
      setCheckedItems(validChecked);
      if (validChecked.length === 0) setSelectedCategoryId(null);
    }
  }, [itemDetailsData, checkedItems]);

  const handleItemizedView = () => {
    if (view) return;
    setIsItemizedView(!isItemizedView);
  };

  const getSelectedItemsData = () => {
    return itemDetailsData.filter((item) => checkedItems.includes(item.unique_id));
  };

  const getGroupedSelectedItems = () => {
    const selectedItems = getSelectedItemsData();
    const grouped = selectedItems.reduce((acc, item) => {
      const categoryId = item.category_id;
      if (!acc[categoryId]) {
        acc[categoryId] = {
          key: categoryId,
          category_id: categoryId,
          category_name: item.category_name,
          items: [],
          totalQty: 0,
          totalAmount: 0,
          totalRequiredQty: 0,
          totalQtyInBomUnit: 0,
          totalBalanceQty: 0,
        };
      }
      acc[categoryId].items.push(item);
      acc[categoryId].totalQty += Number(item.pi_qty || 0);
      acc[categoryId].totalAmount += Number(item.amount || 0);
      acc[categoryId].totalRequiredQty += Number(item.required_qty || 0);
      acc[categoryId].totalQtyInBomUnit += Number(item.qty_in_bom_unit || item.pi_qty || 0);
      acc[categoryId].totalBalanceQty += Number(item.balance_qty || 0);
      return acc;
    }, {});

    return Object.values(grouped);
  };

  const getItemizedViewData = () => {
    const selectedItems = itemDetailsData.filter((item) => checkedItems.includes(item.unique_id));
    const unselectedItems = itemDetailsData.filter((item) => !checkedItems.includes(item.unique_id));

    const grouped = selectedItems.reduce((acc, item) => {
      const categoryId = item.category_id;
      if (!acc[categoryId]) {
        acc[categoryId] = {
          key: `group_${categoryId}`,
          isGroup: true,
          category_id: categoryId,
          category_name: item.category_name,
          items: [],
          totalQty: 0,
          totalAmount: 0,
          totalRequiredQty: 0,
          totalQtyInBomUnit: 0,
          totalBalanceQty: 0,
          styleNumbers: new Set(),
          units: new Set(),
          piUnits: new Set(),
        };
      }
      acc[categoryId].items.push(item);
      acc[categoryId].totalQty += Number(item.pi_qty || 0);
      acc[categoryId].totalAmount += Number(item.amount || 0);
      acc[categoryId].totalRequiredQty += Number(item.required_qty || 0);
      acc[categoryId].totalQtyInBomUnit += Number(item.qty_in_bom_unit || item.pi_qty || 0);
      acc[categoryId].totalBalanceQty += Math.max(0, Number(item.balance_qty || 0));
      if (item.style_no) acc[categoryId].styleNumbers.add(item.style_no);
      if (item.unit_name) acc[categoryId].units.add(item.unit_name);
      const piUnit = unitList.find((unit) => unit.id === (item.pi_unit_id || item.unit_id));
      if (piUnit?.name) acc[categoryId].piUnits.add(piUnit.name);
      return acc;
    }, {});

    const groupedItems = Object.values(grouped).map((group) => ({
      ...group,
      styleNumbers: Array.from(group.styleNumbers).join(", "),
      units: Array.from(group.units).join(", "),
      piUnits: Array.from(group.piUnits).join(", "),
    }));

    const unselectedWithFlag = unselectedItems.map((item) => ({
      ...item,
      isUnselected: true,
    }));

    return [...groupedItems, ...unselectedWithFlag];
  };

  const getGroupPiUnitId = (categoryId, groupData) => {
    return groupPiUnits[categoryId] || groupData.items[0]?.pi_unit_id || groupData.items[0]?.unit_id;
  };

  const getGroupMaxQty = (categoryId) => {
    return groupMaxQty[categoryId] || undefined;
  };

  const handleGroupPiUnitChange = async (categoryId, newUnitId, groupData) => {
    try {
      setGroupPiUnits((prev) => ({
        ...prev,
        [categoryId]: newUnitId,
      }));

      const updatedItemDetailsData = [...itemDetailsData];
      const groupItems = updatedItemDetailsData.filter(
        (item) => item.category_id === categoryId && checkedItems.includes(item.unique_id),
      );

      // Calculate total required quantity in BOM units for max qty calculation
      const totalBomQty = groupItems.reduce((sum, item) => sum + Number(item.required_qty || 0), 0);

      // Get conversion rate for max quantity
      const maxQtyData = {
        convert_from: groupItems[0]?.unit_id,
        convert_to: newUnitId,
        base_value: totalBomQty,
      };

      const maxQtyResponse = await getData(GET_CONVERSION_RATE, false, maxQtyData);
      if (maxQtyResponse?.data?.code === 200) {
        setGroupMaxQty((prev) => ({
          ...prev,
          [categoryId]: maxQtyResponse.data.data,
        }));
      }

      // Update all items in the group with the new unit
      groupItems.forEach((item) => {
        const itemIndex = updatedItemDetailsData.findIndex((dataItem) => dataItem.unique_id === item.unique_id);
        if (itemIndex !== -1) {
          updatedItemDetailsData[itemIndex].pi_unit_id = newUnitId;
        }
      });

      setItemDetailsData(updatedItemDetailsData);
    } catch (error) {}
  };

  const columns = [
    {
      title: "",
      key: "checkbox",
      width: "5%",
      render: (text, record) => {
        const isChecked = checkedItems.includes(record.unique_id);
        const canCheck = canItemBeChecked(record);

        return (
          <Checkbox
            checked={isChecked}
            disabled={view || isItemizedView || (!canCheck && !isChecked)}
            onChange={(e) => handleItemCheck(record, e.target.checked)}
          />
        );
      },
    },
    {
      title: "Item Category",
      dataIndex: "category_name",
      key: "category_name",
      width: "18%",
      render: (text, record) => {
        const isDisabled = !canItemBeChecked(record) && !checkedItems.includes(record.unique_id);
        return (
          <span
            style={{
              color: isDisabled ? "#ccc" : "inherit",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Item Name",
      dataIndex: "item_name",
      key: "item_name",
      width: "18%",
      render: (text, record) => {
        const isDisabled = !canItemBeChecked(record) && !checkedItems.includes(record.unique_id);
        return (
          <span
            style={{
              color: isDisabled ? "#ccc" : "inherit",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Style No",
      dataIndex: "style_no",
      key: "style_no",
      width: "15%",
    },
    {
      title: "BOM",
      children: [
        {
          title: "Qty",
          dataIndex: "required_qty",
          key: "required_qty",
          render: (text, record, idx) => {
            return (
              <InputNumber
                style={{ width: "100px" }}
                disabled={true}
                value={toFixedAndComma(record.required_qty)} // This now shows remaining_qty
                edit={false}
                size="small"
              />
            );
          },
        },
        {
          title: "Unit",
          dataIndex: "unit_name",
          key: "unit_name",
        },
      ],
    },
    {
      title: "PI",
      children: [
        {
          title: "Qty",
          dataIndex: "pi_qty",
          key: "pi_qty",
          render: (text, record, idx) => {
            return (
              <InputNumber
                controls={false}
                precision={2}
                parser={(value) => value.replace(/[^\d.]/g, "")}
                formatter={(value) => value}
                style={{ width: "100px" }}
                disabled={view}
                value={record.pi_qty}
                edit={true}
                onChange={(value) => {
                  getTotalPriceOfItemByPiQty(value, record, record.unique_id, "amount");
                }}
                size="small"
              />
            );
          },
        },
        {
          title: "Unit",
          dataIndex: "pi_unit",
          key: "pi_unit",
          render: (text, record, idx) => {
            return (
              <Select
                showSearch
                disabled={view}
                defaultValue={record?.pi_unit_id || record?.unit_id}
                value={record?.pi_unit_id || record?.unit_id}
                placeholder="Select Unit"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                onSelect={(value) => getConversionData(value, record, itemDetailsData, setItemDetailsData)}
                size="small"
                style={{ width: "100%" }}
              >
                {isArrayAndHasValue(unitList) &&
                  unitList.map((unit) => (
                    <Option key={unit.id} value={unit.id}>
                      {unit.name}
                    </Option>
                  ))}
              </Select>
            );
          },
        },
      ],
    },
    {
      title: "Qty in BOM Unit",
      dataIndex: "qty_in_bom_unit",
      key: "qty_in_bom_unit",
      render: (text, record, idx) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            value={
              !record?.pi_unit_id && !record?.qty_in_bom_unit
                ? record?.pi_qty
                : record?.qty_in_bom_unit
                ? Number(record.qty_in_bom_unit).toFixed(2)
                : 0
            }
            size="small"
          />
        );
      },
    },
    {
      title: "Balance (Remaining)",
      dataIndex: "balance_qty",
      key: "balance_qty",
      render: (text, record, idx) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            value={Number(record.balance_qty).toFixed(2) || 0}
            formatter={(value) => toFixedAndComma(value)}
            size="small"
          />
        );
      },
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      render: (text, record, idx) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={view}
            onChange={(value) => {
              getTotalPriceOfItem(value, record, record.unique_id, "amount");
            }}
            value={record.rate || 0}
            size="small"
          />
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            value={Number(record.amount).toFixed(5) || 0}
            formatter={(value) => toFixedAndComma(value)}
            size="small"
          />
        );
      },
    },
  ];

  const getItemizedColumns = () => {
    return [
      {
        title: "",
        key: "checkbox",
        width: "5%",
        render: (text, record) => {
          if (record.isGroup) return null;
          if (record.isUnselected) return null;
          const isChecked = checkedItems.includes(record.unique_id);
          const canCheck = canItemBeChecked(record);
          return (
            <Checkbox
              checked={isChecked}
              disabled={view || isItemizedView || (!canCheck && !isChecked)}
              onChange={(e) => handleItemCheck(record, e.target.checked)}
            />
          );
        },
      },
      {
        title: "Item Category",
        dataIndex: "category_name",
        key: "category_name",
        width: "18%",
        render: (text, record) => {
          if (record.isGroup) {
            return text;
          }

          return <span style={{}}>{text}</span>;
        },
      },
      {
        title: "Item Name",
        key: "item_name",
        width: "18%",
        render: (text, record) => {
          if (record.isGroup) {
            return `${record.items.length} items selected`;
          }
          return <span>{record.item_name}</span>;
        },
      },
      {
        title: "Style No",
        key: "style_no",
        width: "15%",
        render: (text, record) => {
          if (record.isGroup) return record.styleNumbers || "-";
          return record.style_no;
        },
      },
      {
        title: "BOM",
        children: [
          {
            title: "Qty",
            key: "required_qty",
            width: "10%",
            render: (text, record) => {
              if (record.isGroup) {
                return toFixedAndComma(record.totalRequiredQty);
              }
              return (
                <InputNumber
                  style={{ width: "100px" }}
                  disabled={true}
                  value={toFixedAndComma(record.required_qty)} // This now shows remaining_qty
                  size="small"
                />
              );
            },
          },
          {
            title: "Unit",
            key: "unit_name",
            width: "10%",
            render: (text, record) => {
              if (record.isGroup) return record.units || "-";
              return record.unit_name;
            },
          },
        ],
      },
      {
        title: "PI",
        children: [
          {
            title: "Qty",
            key: "pi_qty",
            width: "10%",
            render: (text, record) => {
              if (record.isGroup) {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <InputNumber
                      style={{
                        width: "100px",
                        fontWeight: "bold",
                        backgroundColor: "#e6f7ff",
                        border: "2px solid #1890ff",
                      }}
                      disabled={view}
                      value={getGroupPiQty(record.category_id, record) || 0}
                      onChange={(value) => handleGroupPiQtyChange(record.category_id, value, record)}
                      size="small"
                      placeholder="Group Total"
                      max={getGroupMaxQty(record.category_id)}
                      min={0}
                      // precision={2}
                      // formatter={(value) => toFixedAndComma(value)}
                    />
                    <span
                      style={{
                        fontSize: "10px",
                        color: "#666",
                        textAlign: "center",
                      }}
                    >
                      Max: {toFixedAndComma(getGroupMaxQty(record.category_id) || record.totalRequiredQty)}
                    </span>
                  </div>
                );
              }

              if (record.isUnselected) {
                return (
                  <InputNumber
                    controls={false}
                    precision={2}
                    parser={(value) => value.replace(/[^\d.]/g, "")}
                    formatter={(value) => value}
                    style={{ width: "100px" }}
                    disabled={view}
                    value={record.pi_qty}
                    onChange={(value) => {
                      getTotalPriceOfItemByPiQty(value, record, record.unique_id, "amount");
                    }}
                    // formatter={(value) => toFixedAndComma(value)}
                    size="small"
                    min={0}
                    max={record.required_qty}
                  />
                );
              }
              return (
                <InputNumber
                  style={{ width: "100px" }}
                  disabled={view}
                  value={record.pi_qty}
                  formatter={(value) => toFixedAndComma(value)}
                  size="small"
                />
              );
            },
          },
          {
            title: "Unit",
            key: "pi_unit",
            width: "10%",
            render: (text, record) => {
              if (record.isGroup) {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <Select
                      showSearch
                      disabled={view}
                      value={getGroupPiUnitId(record.category_id, record)}
                      placeholder="Select Unit"
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      onChange={(value) => {
                        // Get the current total PI qty for this category
                        const currentPiQty = getGroupPiQty(record.category_id, record);

                        // First update the unit
                        handleGroupPiUnitChange(record.category_id, value, record).then(() => {
                          // After unit is updated, redistribute the PI qty if there was any
                          if (currentPiQty > 0) {
                            handleGroupPiQtyChange(record.category_id, currentPiQty, record);
                          }
                        });
                      }}
                      size="small"
                      style={{ width: "100%" }}
                    >
                      {isArrayAndHasValue(unitList) &&
                        unitList.map((unit) => (
                          <Option key={unit.id} value={unit.id}>
                            {unit.name}
                          </Option>
                        ))}
                    </Select>
                    <span
                      style={{
                        fontSize: "10px",
                        color: "#666",
                        textAlign: "center",
                      }}
                    >
                      {record.piUnits || "Select unit"}
                    </span>
                  </div>
                );
              }
              if (record.isUnselected) {
                return (
                  <Select
                    showSearch
                    disabled={view}
                    value={record?.pi_unit_id || record?.unit_id}
                    placeholder="Select Unit"
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    onSelect={(value) => getConversionData(value, record, itemDetailsData, setItemDetailsData)}
                    size="small"
                    style={{ width: "100%" }}
                  >
                    {isArrayAndHasValue(unitList) &&
                      unitList.map((unit) => (
                        <Option key={unit.id} value={unit.id}>
                          {unit.name}
                        </Option>
                      ))}
                  </Select>
                );
              }
              const piUnit = unitList.find((unit) => unit.id === (record.pi_unit_id || record.unit_id));
              return piUnit?.name || record.unit_name || "-";
            },
          },
        ],
      },

      {
        title: "Qty in BOM Unit",
        key: "qty_in_bom_unit",
        width: "10%",
        render: (text, record) => {
          if (record.isGroup) {
            // Use parentGroupBomQty for parent group row
            return (
              <InputNumber
                style={{ width: "100px" }}
                disabled={true}
                value={
                  parentGroupBomQty[record.category_id] !== undefined
                    ? Number(parentGroupBomQty[record.category_id]).toFixed(2)
                    : Number(record.totalQtyInBomUnit).toFixed(2)
                }
                formatter={(value) => toFixedAndComma(value)}
                size="small"
              />
            );
          }
          return (
            <InputNumber
              style={{ width: "100px" }}
              disabled={true}
              value={
                !record?.pi_unit_id && !record?.qty_in_bom_unit
                  ? record?.pi_qty
                  : record?.qty_in_bom_unit
                  ? Number(record.qty_in_bom_unit).toFixed(2)
                  : 0
              }
              formatter={(value) => toFixedAndComma(value)}
              size="small"
            />
          );
        },
      },

      {
        title: "Balance (Remaining)",
        key: "balance_qty",
        width: "10%",
        render: (text, record) => {
          if (record.isGroup) {
            // For group row, calculate total balance based on BOM qty - qty in BOM unit
            const totalBalance =
              record.totalRequiredQty - (parentGroupBomQty[record.category_id] || record.totalQtyInBomUnit);
            return toFixedAndComma(Math.max(0, totalBalance).toFixed(2));
          }

          // For individual items, calculate balance as BOM qty - qty in BOM unit
          const balance =
            record.required_qty -
            (!record?.pi_unit_id && !record?.qty_in_bom_unit ? record?.pi_qty : record?.qty_in_bom_unit || 0);

          return (
            <InputNumber
              style={{ width: "100px" }}
              disabled={true}
              value={Math.max(0, Number(balance)).toFixed(2)}
              formatter={(value) => toFixedAndComma(value)}
              size="small"
            />
          );
        },
      },
      {
        title: "Rate",
        key: "rate",
        width: "10%",
        render: (text, record) => {
          if (record.isGroup) {
            return (
              <InputNumber
                style={{
                  width: "100px",
                  fontWeight: "bold",
                  backgroundColor: "#fff7e6",
                }}
                disabled={view}
                value={getGroupRate(record.category_id)}
                onChange={(value) => {
                  handleGroupRateChange(record.category_id, value);
                }}
                size="small"
                placeholder="Group Rate"
                min={0}
              />
            );
          }

          if (record.isUnselected) {
            return (
              <InputNumber
                style={{ width: "100px" }}
                disabled={view}
                onChange={(value) => {
                  getTotalPriceOfItem(value, record, record.unique_id, "amount");
                }}
                value={record.rate || 0}
                size="small"
                min={0}
              />
            );
          }
          return (
            <InputNumber
              style={{ width: "100px" }}
              disabled={view}
              onChange={(value) => {
                getTotalPriceOfItem(value, record, record.unique_id, "amount");
              }}
              value={record.rate || 0}
              size="small"
            />
          );
        },
      },
      {
        title: "Amount",
        key: "amount",
        width: "10%",
        render: (text, record) => {
          if (record.isGroup) {
            return toFixedAndComma(record.totalAmount);
          }
          return (
            <InputNumber
              style={{ width: "100px" }}
              disabled={true}
              value={Number(record.amount).toFixed(5) || 0}
              formatter={(value) => toFixedAndComma(value)}
              size="small"
            />
          );
        },
      },
    ];
  };

  const nestedColumns = [
    {
      title: "Item Category",
      dataIndex: "category_name",
      key: "category_name",
      width: "18%",
    },
    {
      title: "Item Name",
      dataIndex: "item_name",
      key: "item_name",
      width: "22%",
    },
    {
      title: "Style No",
      dataIndex: "style_no",
      key: "style_no",
      width: "15%",
    },
    {
      title: "BOM",
      children: [
        {
          title: "Qty",
          key: "required_qty",
          width: "10%",
          render: (text, item) => (
            <InputNumber style={{ width: "100px" }} disabled={true} value={item.required_qty} size="small" />
          ),
        },
        {
          title: "Unit",
          dataIndex: "unit_name",
          key: "unit_name",
          width: "10%",
        },
      ],
    },
    {
      title: "PI",
      children: [
        {
          title: "Qty",
          key: "pi_qty",
          width: "10%",
          render: (text, item, index) => {
            if (!item.isGroup) {
              return (
                <InputNumber
                  controls={false}
                  precision={2}
                  parser={(value) => value.replace(/[^\d.]/g, "")}
                  formatter={(value) => value}
                  style={{ width: "100px" }}
                  disabled={view}
                  value={item.pi_qty}
                  onChange={(value) => {
                    getTotalPriceOfItemByPiQty(value, item, item.unique_id, "amount");
                  }}
                  size="small"
                  min={0}
                  max={item.required_qty}
                />
              );
            }

            return (
              <InputNumber
                style={{ width: "100px" }}
                disabled={true}
                value={item.pi_qty}
                formatter={(value) => toFixedAndComma(value)}
                size="small"
                max={item.required_qty}
                min={0}
              />
            );
          },
        },
        {
          title: "Unit",
          key: "pi_unit",
          width: "10%",
          render: (text, item) => (
            <Select
              showSearch
              disabled={true}
              value={item?.pi_unit_id || item?.unit_id}
              placeholder="Select Unit"
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
              size="small"
              style={{ width: "100%" }}
            >
              {isArrayAndHasValue(unitList) &&
                unitList.map((unit) => (
                  <Option key={unit.id} value={unit.id}>
                    {unit.name}
                  </Option>
                ))}
            </Select>
          ),
        },
      ],
    },
    {
      title: "Qty in BOM Unit",
      dataIndex: "qty_in_bom_unit",
      key: "qty_in_bom_unit",
      render: (text, item, idx) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            value={
              !item?.pi_unit_id && !item?.qty_in_bom_unit
                ? item?.pi_qty
                : item?.qty_in_bom_unit
                ? Number(item.qty_in_bom_unit).toFixed(2)
                : 0
            }
            size="small"
          />
        );
      },
    },
    {
      title: "Balance (Remaining)",
      dataIndex: "balance_qty",
      key: "balance_qty",
      render: (text, item, idx) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            value={Math.max(0, Number(item.balance_qty)).toFixed(2) || 0}
            formatter={(value) => toFixedAndComma(value)}
            size="small"
          />
        );
      },
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      render: (text, item, idx) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            onChange={(value) => {
              getTotalPriceOfItem(value, item, item.unique_id, "amount");
            }}
            value={item.rate || 0}
            size="small"
          />
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text, item) => {
        return (
          <InputNumber
            style={{ width: "100px" }}
            disabled={true}
            value={Number(item.amount).toFixed(5) || 0}
            formatter={(value) => toFixedAndComma(value)}
            size="small"
          />
        );
      },
    },
  ];

  const categoryMapColumns = [
    {
      title: "Item Category",
      dataIndex: ["item_category_info", "name"],
      key: "item_type",
      width: "50%",
    },
    {
      title: "Expected In House Date",
      dataIndex: "expected_in_house_date",
      key: "expected_in_house_date",
      width: "50%",
      render: (value, record, idx) => {
        return (
          <CustomDatePicker
            style={{ width: "100%" }}
            disabled={view}
            size="small"
            value={value ? moment(value) : null}
            onChange={(dateString) => onChangeInHouseDate(dateString, record)}
          />
        );
      },
    },
  ];

  const TableSummary = (pageData) => {
    let totalPiQty = 0;
    let totalAmount = 0;

    pageData?.pageData?.forEach((item) => {
      totalPiQty = totalPiQty + Number(item.pi_qty);
      totalAmount = totalAmount + Number(item.amount);
    });

    const totalData = {
      totalPiQty: totalPiQty ? totalPiQty.toFixed(2) : 0,
      totalAmount: totalAmount ? totalAmount.toFixed(2) : 0,
    };

    return (
      <Table.Summary fixed>
        <Table.Summary.Row style={{ backgroundColor: "#F5F5F5" }}>
          <Table.Summary.Cell index={0}>
            <strong>Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={2} index={1}></Table.Summary.Cell>
          <Table.Summary.Cell index={2}></Table.Summary.Cell>
          <Table.Summary.Cell index={3}></Table.Summary.Cell>
          <Table.Summary.Cell index={4}></Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            {totalData?.totalPiQty ? toFixedAndComma(totalData?.totalPiQty) : 0}
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}></Table.Summary.Cell>
          <Table.Summary.Cell index={7}></Table.Summary.Cell>
          <Table.Summary.Cell index={8}></Table.Summary.Cell>
          <Table.Summary.Cell index={9}></Table.Summary.Cell>
          <Table.Summary.Cell index={10}>
            {totalData?.totalAmount ? toFixedAndComma(totalData?.totalAmount) : 0}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    );
  };

  const handleGroupPiQtyChange = async (categoryId, value, groupData) => {
    try {
      if (!value) {
        setGroupPiQuantities((prev) => ({
          ...prev,
          [categoryId]: 0,
        }));
        return;
      }

      const updatedItemDetailsData = [...itemDetailsData];
      const groupItems = updatedItemDetailsData.filter(
        (item) => item.category_id === categoryId && checkedItems.includes(item.unique_id),
      );

      const bomUnitId = groupItems[0]?.unit_id;
      const piUnitId = groupItems[0]?.pi_unit_id || groupItems[0]?.unit_id;

      // First convert total PI quantity to BOM unit to check max limit
      const totalBomConversion = {
        convert_from: piUnitId,
        convert_to: bomUnitId,
        base_value: value,
      };

      const totalBomResponse = await getData(GET_CONVERSION_RATE, false, totalBomConversion);
      const totalInBomUnit = totalBomResponse?.data?.code === 200 ? totalBomResponse.data.data : value;

      // Validate against total BOM quantity (now using remaining_qty)
      const totalBomQty = groupData.totalRequiredQty;
      if (totalInBomUnit > totalBomQty) {
        alertPop("warning", `PI quantity cannot exceed remaining BOM quantity (${toFixedAndComma(totalBomQty)})`);
        return;
      }

      // Store total BOM qty for parent display
      setParentGroupBomQty((prev) => ({
        ...prev,
        [categoryId]: totalInBomUnit,
      }));

      // Reset all items first
      groupItems.forEach((item, idx) => {
        const itemIndex = updatedItemDetailsData.findIndex((dataItem) => dataItem.unique_id === item.unique_id);
        if (itemIndex !== -1) {
          updatedItemDetailsData[itemIndex].pi_qty = 0;
          updatedItemDetailsData[itemIndex].qty_in_bom_unit = 0;
          updatedItemDetailsData[itemIndex].balance_qty = item.required_qty;
          updatedItemDetailsData[itemIndex].amount = 0;
        }
      });

      // Get conversion rate from BOM to PI for child distribution
      const conversionData = {
        convert_from: bomUnitId,
        convert_to: piUnitId,
        base_value: 1,
      };

      const response = await getData(GET_CONVERSION_RATE, false, conversionData);
      const conversionRate = response?.data?.code === 200 ? response.data.data : 1;

      // Distribute quantities
      let remainingPiQty = value;
      let remainingBomQty = totalInBomUnit;

      for (let i = 0; i < groupItems.length && remainingPiQty > 0; i++) {
        const item = groupItems[i];
        const itemIndex = updatedItemDetailsData.findIndex((dataItem) => dataItem.unique_id === item.unique_id);

        if (itemIndex !== -1) {
          const itemBomQty = updatedItemDetailsData[itemIndex].required_qty;
          const maxBomQtyForThis = Math.min(remainingBomQty, itemBomQty);
          const maxPiQtyForThis = maxBomQtyForThis * conversionRate;
          const allocatedPiQty = Math.min(remainingPiQty, maxPiQtyForThis);

          updatedItemDetailsData[itemIndex].pi_qty = allocatedPiQty;
          updatedItemDetailsData[itemIndex].qty_in_bom_unit = maxBomQtyForThis;
          updatedItemDetailsData[itemIndex].balance_qty = Math.max(0, itemBomQty - maxBomQtyForThis);
          updatedItemDetailsData[itemIndex].amount = allocatedPiQty * (updatedItemDetailsData[itemIndex].rate || 0);

          remainingPiQty -= allocatedPiQty;
          remainingBomQty -= maxBomQtyForThis;
        }
      }

      setItemDetailsData(updatedItemDetailsData);
      setGroupPiQuantities((prev) => ({
        ...prev,
        [categoryId]: value,
      }));
    } catch (error) {}
  };
  const handleGroupRateChange = (categoryId, rate) => {
    const updatedItemDetailsData = [...itemDetailsData];
    const groupItems = updatedItemDetailsData.filter(
      (item) => item.category_id === categoryId && checkedItems.includes(item.unique_id),
    );

    groupItems.forEach((item) => {
      const itemIndex = updatedItemDetailsData.findIndex((dataItem) => dataItem.unique_id === item.unique_id);
      if (itemIndex !== -1) {
        updatedItemDetailsData[itemIndex].rate = rate || 0;
        updatedItemDetailsData[itemIndex].amount = (updatedItemDetailsData[itemIndex].pi_qty || 0) * (rate || 0);
      }
    });

    setItemDetailsData(updatedItemDetailsData);
  };

  const getGroupRate = (categoryId) => {
    const groupItems = itemDetailsData.filter(
      (item) => item.category_id === categoryId && checkedItems.includes(item.unique_id),
    );

    const rates = groupItems.map((item) => item.rate || 0);
    const uniqueRates = [...new Set(rates)];

    return uniqueRates.length === 1 ? uniqueRates[0] : 0;
  };

  useEffect(() => {
    if (checkedItems.length > 0) {
      const newGroupQuantities = {};

      const checkedCategories = [
        ...new Set(
          itemDetailsData.filter((item) => checkedItems.includes(item.unique_id)).map((item) => item.category_id),
        ),
      ];

      checkedCategories.forEach((categoryId) => {
        const categoryItems = itemDetailsData.filter(
          (item) => item.category_id === categoryId && checkedItems.includes(item.unique_id),
        );
        const actualTotal = categoryItems.reduce((sum, item) => sum + (item.pi_qty || 0), 0);
        newGroupQuantities[categoryId] = actualTotal;
      });

      setGroupPiQuantities(newGroupQuantities);
    } else {
      setGroupPiQuantities({});
    }
  }, [checkedItems, itemDetailsData]);

  const getGroupPiQty = (categoryId, groupData) => {
    const groupItems = itemDetailsData.filter(
      (item) => item.category_id === categoryId && checkedItems.includes(item.unique_id),
    );

    const actualTotal = groupItems.reduce((sum, item) => sum + (item.pi_qty || 0), 0);

    return actualTotal;
  };

  useEffect(() => {
    if (categoryFilter.length > 0) {
      const filteredIds = itemDetailsData
        .filter((item) => categoryFilter.includes(item.category_id))
        .map((item) => item.unique_id);
      setCheckedItems(filteredIds);

      if (filteredIds.length > 0 && selectedCategoryId === null) {
        setSelectedCategoryId(
          itemDetailsData.find((item) => filteredIds.includes(item.unique_id))?.category_id || null,
        );
      }
    } else if (categoryFilter.length === 0 && checkedItems.length > 0) {
      setCheckedItems([]);
      setSelectedCategoryId(null);
    }
  }, [categoryFilter, itemDetailsData]);

  return (
    <div className="containt-body">
      <Form layout="vertical" form={form} name="control-hooks" onFinish={onFinishSalesContract}>
        <Card>
          <Row gutter={6}>
            <Col className="gutter-row" span={4}>
              <Form.Item
                label="Sales Contract Ref No"
                name="sales_contract_id"
                rules={[
                  {
                    required: true,
                    message: "Sales Contract is required",
                  },
                ]}
              >
                <Select
                  placeholder="Sales Contract"
                  showSearch
                  style={{ width: "100%" }}
                  onChange={handleSalesContractChange}
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  disabled={view}
                  onSearch={debouncedGetSalesContractList}
                  allowClear
                  onClear={getSalesContractList}
                  size="small"
                >
                  {salesContractList.map((option) => (
                    <Option key={option.id} value={option.id}>
                      {option.reference_no}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item
                label="PI No"
                name="pi_number"
                rules={[
                  {
                    required: true,
                    message: "PI Number is required",
                  },
                ]}
              >
                <Input className="w-100" disabled={view} size="small" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="PI Date" name="pi_date">
                <CustomDatePicker style={{ width: "100%" }} disabled={view} size="small" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item
                label="Supplier Name"
                name="supplier_id"
                rules={[
                  {
                    required: true,
                    message: "Supplier Name is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select a Supplier"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  disabled={view}
                  size="small"
                  onChange={(value) => {
                    const selectedStyleIds = form.getFieldValue("style_no");
                    if (selectedStyleIds !== "undefined" && selectedStyleIds && selectedStyleIds.length > 0) {
                      getItemDetails(selectedStyleIds, value);
                    }
                  }}
                >
                  {supplier?.length &&
                    supplier.map((buy) => (
                      <Option value={buy?.id} key={buy?.id}>
                        {buy.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item
                label="Style No"
                name="style_no"
                rules={[
                  {
                    required: true,
                    message: "Style No is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select Style"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  disabled={view}
                  mode="multiple"
                  onChange={(value) => {
                    getItemDetails(value);
                  }}
                  size="small"
                >
                  {styleNo?.length &&
                    styleNo.map((item) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item
                label="Description of Goods"
                name="goods_description"
                rules={[
                  {
                    required: true,
                    message: "Description of Goods is required",
                  },
                ]}
              >
                <Select placeholder="Description of Goods" style={{ width: "100%" }} disabled={view} size="small">
                  <option value="Fabric">Fabric</option>
                  <option value="Accessories">Accessories</option>
                  <option value="Print">Print</option>
                  <option value="Washing">Washing</option>
                  <option value="Embroidery">Embroidery</option>
                  <option value="Testing">Testing Charge</option>
                  <option value="Inspection">Inspection Charge</option>
                  <option value="Courier">Courier Charge</option>
                  <option value="Portal">Portal Charge</option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Buyer" name="buyer">
                <Input disabled={true} style={{ width: "100%", color: "#000" }} size="small" />
              </Form.Item>
            </Col>
            <Col span={4} hidden>
              <Form.Item label="Buyer ID" name="buyer_id">
                <Input disabled={true} style={{ width: "100%", color: "#000" }} size="small" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Items Value" name="items_value">
                <InputNumber
                  style={{ width: "100%", color: "#000" }}
                  disabled={true}
                  formatter={(value) => toFixedAndComma(value)}
                  precision={2}
                  size="small"
                />
              </Form.Item>
              <Form.Item name="items_quantity">
                <Input
                  className="w-100"
                  disabled={true}
                  style={{ width: "100%", color: "#000" }}
                  type="hidden"
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Service Charge" name="service_charge">
                <Input style={{ width: "100%" }} disabled={view} onChange={updatePiValueByService} size="small" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Additional Charge" name="additional_charge">
                <Input
                  style={{ width: "100%" }}
                  disabled={view}
                  onChange={updatePiValueByAdditionalCharge}
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Deduction Amount" name="deduction_amount">
                <Input
                  style={{ width: "100%" }}
                  disabled={view}
                  onChange={updatePiValueByDeductionAmount}
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="PI Value" name="pi_value">
                <InputNumber
                  style={{ width: "100%", color: "#000" }}
                  disabled={true}
                  formatter={(value) => toFixedAndComma(value)}
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="Trade/Freight Term" name="trade_term">
                <Select placeholder="Trade/Freight Term" style={{ width: "100%" }} disabled={view} size="small">
                  <option value="EXW (Ex-Works)">EXW (Ex-Works)</option>
                  <option value="FCA (Free Carrier)">FCA (Free Carrier)</option>
                  <option value="FAS (Free Alongside Ship)">FAS (Free Alongside Ship)</option>
                  <option value="FOB (Free on Board)">FOB (Free on Board)</option>
                  <option value="CFR (Cost & Freight)">CFR (Cost & Freight)</option>
                  <option value="CIF (Cost Insurance & Freight)">CIF (Cost Insurance & Freight)</option>
                  <option value="CPT ( Carriage Paid To)">CPT ( Carriage Paid To)</option>
                  <option value="CIP (Carriage Insurance Paid To)">CIP (Carriage Insurance Paid To)</option>
                  <option value="DPU (Delivered at Place Unloaded)">DPU (Delivered at Place Unloaded)</option>
                  <option value="DAT (Delivered At Terminal)">DAT (Delivered At Terminal)</option>
                  <option value="DAP (Delivered at Place)">DAP (Delivered at Place)</option>
                  <option value="DDP (Delivered Duty Paid)">DDP (Delivered Duty Paid)</option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="Payment Term" name="pay_term">
                <Input className="w-100" disabled={view} size="small" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="Payment Mode" name="payment_mode">
                <Select placeholder="Payment Mode" style={{ width: "100%" }} disabled={view} size="small">
                  <option value="LC">LC (Letter of Credit)</option>
                  <option value="TT">TT (Telegraphic Transfer)</option>
                  <option value="FDD">FDD (Foreign Demand Draft)</option>
                  <option value="RTGS">RTGS (Real-time gross settlement)</option>
                  <option value="RTGS-CASH">RTGS cash against documents</option>
                  <option value="Cash">Cash</option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="Ship Mode" name="ship_mode">
                <Select placeholder="Ship Mode" style={{ width: "100%" }} disabled={view} size="small">
                  <option value="SEA">SEA</option>
                  <option value="AIR">AIR</option>
                  <option value="LAND">LAND</option>
                  <option value="TRANSPORT">TRANSPORT</option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="Ship Date" name="ship_date">
                <CustomDatePicker style={{ width: "100%" }} disabled={view} size="small" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item label="ETA" name="eta">
                <CustomDatePicker style={{ width: "100%" }} disabled={view} size="small" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="is_b2blc_open"
                label="Is B2B LC Open"
                className="collection-create-form_last-form-item"
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" disabled={view} size="small" />
              </Form.Item>
            </Col>
            {show_approve === 1 ? (
              <>
                <Col span={4}>
                  <Form.Item label="Status" name="status">
                    <Select placeholder="Status" style={{ width: "100%" }} size="small" disabled={view}>
                      <option value="Created">Created</option>
                      <option value="Approved">Approved</option>
                      <option value="Rejected">Rejected</option>
                      <option value="Updated">Updated</option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    name="is_nominated"
                    label="Is Nominated"
                    className="collection-create-form_last-form-item"
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Switch checkedChildren="Yes" unCheckedChildren="No" disabled={view} size="small" />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item disabled={view} label="Comment" name="comment">
                    <Input className="w-100" size="small" />
                  </Form.Item>
                </Col>
              </>
            ) : (
              <>
                <Col span={4}>
                  <Form.Item label="Status" name="status">
                    <Select
                      placeholder="Status"
                      defaultValue="Created"
                      style={{ width: "100%" }}
                      size="small"
                      disabled={view}
                    >
                      <option value="Created">Created</option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    name="is_nominated"
                    label="Is Nominated"
                    className="collection-create-form_last-form-item"
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Switch checkedChildren="Yes" unCheckedChildren="No" disabled={view} size="small" />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </Card>
        <Affix>
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "14px" }}>Item Details</span>
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                {/* Category filter multi-select */}
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Filter by Category"
                  style={{ minWidth: 200 }}
                  size="small"
                  value={categoryFilter}
                  onChange={setCategoryFilter}
                  disabled={view}
                >
                  {isArrayAndHasValue(categoryMapData) &&
                    categoryMapData.map((cat) => (
                      <Option key={cat.item_category_id} value={cat.item_category_id}>
                        {cat.item_category_info?.name || "-"}
                      </Option>
                    ))}
                </Select>
                {checkedItems.length > 1 && !view && (
                  <Button
                    type={isItemizedView ? "default" : "primary"}
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={handleItemizedView}
                    disabled={view}
                  >
                    {isItemizedView ? "Normal view" : "Itemized view"}
                  </Button>
                )}
                {isItemizedView && checkedItems.length > 1 && (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      alignSelf: "center",
                    }}
                  >
                    Showing {checkedItems.length} selected items
                  </span>
                )}
              </div>
            </div>
          </Card>
        </Affix>
        <Card>
          {isItemizedView ? (
            <Table
              dataSource={getItemizedViewData()}
              columns={getItemizedColumns()}
              expandable={{
                expandedRowRender: (record) => {
                  if (!record.isGroup) return null;

                  const nestedColumns = [
                    {
                      title: "Item Category",
                      dataIndex: "category_name",
                      key: "category_name",
                      width: "18%",
                    },
                    {
                      title: "Item Name",
                      dataIndex: "item_name",
                      key: "item_name",
                      width: "22%",
                    },
                    {
                      title: "Style No",
                      dataIndex: "style_no",
                      key: "style_no",
                      width: "15%",
                    },
                    {
                      title: "BOM",
                      children: [
                        {
                          title: "Qty",
                          key: "required_qty",
                          width: "10%",
                          render: (text, item) => (
                            <InputNumber
                              style={{ width: "100px" }}
                              disabled={true}
                              value={item.required_qty}
                              size="small"
                            />
                          ),
                        },
                        {
                          title: "Unit",
                          dataIndex: "unit_name",
                          key: "unit_name",
                          width: "10%",
                        },
                      ],
                    },
                    {
                      title: "PI",
                      children: [
                        {
                          title: "Qty",
                          key: "pi_qty",
                          width: "10%",
                          render: (text, item, index) => {
                            if (!item.isGroup) {
                              return (
                                <InputNumber
                                  controls={false}
                                  precision={2}
                                  parser={(value) => value.replace(/[^\d.]/g, "")}
                                  formatter={(value) => value}
                                  style={{ width: "100px" }}
                                  disabled={view}
                                  value={item.pi_qty}
                                  onChange={(value) => {
                                    getTotalPriceOfItemByPiQty(value, item, item.unique_id, "amount");
                                  }}
                                  size="small"
                                  min={0}
                                  max={item.required_qty}
                                />
                              );
                            }

                            return (
                              <InputNumber
                                style={{ width: "100px" }}
                                disabled={true}
                                value={item.pi_qty}
                                formatter={(value) => toFixedAndComma(value)}
                                size="small"
                                max={item.required_qty}
                                min={0}
                              />
                            );
                          },
                        },
                        {
                          title: "Unit",
                          key: "pi_unit",
                          width: "10%",
                          render: (text, item) => (
                            <Select
                              showSearch
                              disabled={true}
                              value={item?.pi_unit_id || item?.unit_id}
                              placeholder="Select Unit"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              size="small"
                              style={{ width: "100%" }}
                            >
                              {isArrayAndHasValue(unitList) &&
                                unitList.map((unit) => (
                                  <Option key={unit.id} value={unit.id}>
                                    {unit.name}
                                  </Option>
                                ))}
                            </Select>
                          ),
                        },
                      ],
                    },
                    {
                      title: "Qty in BOM Unit",
                      key: "qty_in_bom_unit",
                      width: "10%",
                      render: (text, item) => (
                        <InputNumber
                          style={{ width: "100px" }}
                          disabled={true}
                          value={
                            !item?.pi_unit_id && !item?.qty_in_bom_unit
                              ? item?.pi_qty
                              : item?.qty_in_bom_unit
                              ? Number(item.qty_in_bom_unit).toFixed(2)
                              : 0
                          }
                          formatter={(value) => toFixedAndComma(value)}
                          size="small"
                        />
                      ),
                    },

                    {
                      title: "Balance (Remaining)",
                      key: "balance_qty",
                      width: "10%",
                      render: (text, item) => {
                        // For items with PI unit conversion
                        if (item?.pi_unit_id && item?.pi_unit_id !== item?.unit_id) {
                          const balance = item.required_qty - (item?.qty_in_bom_unit || 0);
                          return (
                            <InputNumber
                              style={{ width: "100px" }}
                              disabled={true}
                              value={Math.max(0, Number(balance)).toFixed(2)}
                              formatter={(value) => toFixedAndComma(value)}
                              size="small"
                            />
                          );
                        }

                        // For items without unit conversion
                        const balance = item.required_qty - (item?.pi_qty || 0);
                        return (
                          <InputNumber
                            style={{ width: "100px" }}
                            disabled={true}
                            value={Math.max(0, Number(balance)).toFixed(2)}
                            formatter={(value) => toFixedAndComma(value)}
                            size="small"
                          />
                        );
                      },
                    },
                    {
                      title: "Rate",
                      key: "rate",
                      width: "10%",
                      render: (text, item) => (
                        <InputNumber
                          style={{ width: "100px" }}
                          disabled={true}
                          onChange={(value) => {
                            getTotalPriceOfItem(value, item, item.unique_id, "amount");
                          }}
                          value={item.rate || 0}
                          size="small"
                        />
                      ),
                    },
                    {
                      title: "Amount",
                      key: "amount",
                      width: "10%",
                      render: (text, item) => (
                        <InputNumber
                          style={{ width: "100px" }}
                          disabled={true}
                          value={Number(item.amount).toFixed(5) || 0}
                          formatter={(value) => toFixedAndComma(value)}
                          size="small"
                        />
                      ),
                    },
                  ];

                  return (
                    <Table
                      dataSource={record.items}
                      columns={nestedColumns}
                      pagination={false}
                      showHeader={false}
                      size="small"
                      bordered
                      style={{}}
                      rowClassName={() => "nested-table-row"}
                      onRow={(record) => ({
                        style: {
                          backgroundColor: "#f0f8ff",
                          borderLeft: "3px solid #1890ff",
                        },
                      })}
                      scroll={{ x: "max-content" }}
                    />
                  );
                },

                rowExpandable: (record) => record.isGroup && record.items && record.items.length > 0,
                defaultExpandAllRows: true,
                expandIcon: ({ expanded, onExpand, record }) => {
                  if (!record.isGroup) return null;
                  return expanded ? (
                    <span onClick={(e) => onExpand(record, e)} style={{ cursor: "pointer", marginRight: "8px" }}>
                      -
                    </span>
                  ) : (
                    <span onClick={(e) => onExpand(record, e)} style={{ cursor: "pointer", marginRight: "8px" }}>
                      +
                    </span>
                  );
                },
              }}
              pagination={false}
              size="small"
              bordered
              scroll={{ x: "max-content" }}
              components={{
                header: {
                  cell: (props) => (
                    <th
                      {...props}
                      className="fixed-width-header"
                      style={{
                        background: "#1b4b72",
                        color: "#fff",
                        fontWeight: 500,
                      }}
                    />
                  ),
                },
              }}
              className="itemized-table"
            />
          ) : (
            <Table
              dataSource={itemDetailsData}
              columns={columns}
              summary={(pageData) => {
                return <TableSummary pageData={pageData} />;
              }}
              size="small"
              bordered
              loading={isItemsLoading}
              pagination={{ pageSize: 10 }}
            />
          )}
        </Card>
        <Affix>
          <Card>
            <span style={{ fontSize: "14px" }}>Expected Inhouse Data</span>
          </Card>
        </Affix>
        <Card>
          <Table dataSource={categoryMapData} columns={categoryMapColumns} size="small" bordered />
        </Card>
      </Form>
      <ImportPiDocument DOC_ADD={IMPORT_PI_ADD_DOC} setFileList={setFileList} filesList={filesList} view={view} />
      {b2bLcDocuments.length > 0 ? <ImportB2blcDocument filesList={b2bLcDocuments} view={view} /> : ""}
    </div>
  );
});

export default AddExportSalesContractForm;
